var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24256_67204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9909 11.7199C28.9909 13.6719 29.0817 15.5786 28.6802 17.4977C26.8042 26.4593 17.0078 31.5054 8.58501 27.7409C0.435567 24.1001 -2.5622 13.9147 2.44315 6.43556C7.07422 -0.483249 16.7379 -2.14376 23.3277 3.02606L19.9511 7.35542C15.8736 4.26237 9.9563 5.20492 7.08669 9.43786C4.08665 13.8625 5.57476 19.8796 10.2467 22.3998C15.2066 25.0755 21.2907 22.5269 23.0453 17.2731H14.4944V11.7222H28.9909V11.7199Z",
    fill: "#AE8E66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24256_67204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ee027647124387f1d3219a3e31830922.svg";
export { ForwardRef as ReactComponent };